export default {
  async quote (args) {
    let from = args['currency-from'] || "USD",
      to = args['currency-to'] || "BRL",
      mount = args.mount || 1
    return await axios.post(`finance/currency/quote/${from}-${to}`, { mount })
  }
}
